import React, { ReactElement } from 'react';
import { Tabs } from 'antd';
import EmailVerification from './tabs/emailVerification/TabEmailVerification';
import { useHistory, useParams } from 'react-router-dom';
import EmailComponentsList from './tabs/emailComponents/EmailComponentList';
import TabSecureMode from './tabs/security/TabSecureMode';
import OrganizationSettingsTab from './tabs/organization/OrganizationSettingsTab';
import TeamManagementContainer from './tabs/team/TeamManagementContainer';
import PushSettingsContainer from './tabs/push/PushSettingsContainer';
import PlanContainer from '../plan/PlanContainer';

const SettingsPage = (): ReactElement => {
  const { tabId } = useParams<{ tabId: string }>();
  const { accountId } = useParams<{ accountId: string }>();
  const history = useHistory();
  const changeTab = (key: string): void => {
    history.push(`/${accountId}/settings/${key}`);
  };

  return (
    <div>
      <Tabs
        animated={false}
        type="card"
        activeKey={tabId}
        onTabClick={changeTab}
        size={'large'}
        tabBarStyle={{
          backgroundColor: '#fff',
          padding: '0 24px',
          minHeight: '42px'
        }}
      >
        <Tabs.TabPane tab="Team" key="team" closable={false}>
          <TeamManagementContainer />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab="Domain Verification"
          key="domain-verification"
          closable={false}
        >
          <EmailVerification />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Branding" key="organization">
          <OrganizationSettingsTab />
        </Tabs.TabPane>
        <Tabs.TabPane
          tab="Email Components"
          key="email-components"
          closable={false}
        >
          <EmailComponentsList />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Security" key="security" closable={false}>
          <TabSecureMode />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Push" key="push" closable={false}>
          <PushSettingsContainer />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Plan" key="plan" closable={false}>
          <PlanContainer />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
};
export default SettingsPage;
